import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../../services/shared-data.service';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    standalone: false
})
export class ReviewComponent implements OnInit {

  isLoading = false;

  constructor(private _sharedDataService: SharedDataService) {}

  ngOnInit() {
    this._sharedDataService.pageHeaderTitle$.next('Submission Review Queue');
  }
}
